/* global React */
/* eslint-disable no-restricted-globals */
import fileConfig from 'config/web/ui/_shared/file.json5'
import { FileIcon } from 'ui/Element/Icon'
import { type PlaceholderProps } from 'ui/Element/Image'
import { getPlaceholderGroup } from 'platform/react/hook/useImage'

/**
 * Placeholder Element
 *
 * Displays a file-type placeholder for a given filename
 *
 * @param props           the element's properties
 * @param props.name      filename to derive the placeholder from
 * @param props.types     file type map, defaults to the app's file config
 * @param props.iconProps styling applied to the file icon
 * @returns               the new placeholder element
 */
const Placeholder = ({
  name = null, types = fileConfig.types, iconProps = {},
}: PlaceholderProps) => (
  <FileIcon
    name={getPlaceholderGroup(name, types)}
    size={'100%'}
    {...iconProps}
  />
)

export default Placeholder
